/**
 * Copyright (c) Simam Digital. Built on Project Flowerbed
 * (Copyright (c) Meta Platforms, Inc. and affiliates).
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { Component, Types } from 'ecsy';

/**
 * The player's coin balance for the grow-a-garden economy. A single instance
 * lives on the wallet singleton entity created by GardenEconomySystem.
 */
export class PlayerWalletComponent extends Component {}

PlayerWalletComponent.schema = {
	/** @type {number} - spendable coins */
	coins: { type: Types.Number, default: 0 },
	/** @type {number} - lifetime coins earned from harvesting (stats) */
	totalEarned: { type: Types.Number, default: 0 },
	/** @type {boolean} - set when coins change so the HUD/save can react */
	dirty: { type: Types.Boolean, default: false },
};

/**
 * The player's real-world region and its signature seed ("Living World" hook).
 */
export class RegionComponent extends Component {}

RegionComponent.schema = {
	/** @type {string} - loose region hint, e.g. 'JP', 'US' */
	region: { type: Types.String, default: '' },
	/** @type {string} - the family key of the region's signature seed */
	signatureSeed: { type: Types.String, default: '' },
};
